import { UserModelProps } from '.';

export type UserModelSelfValidationBusinessRuleType = (userModelProps: UserModelProps) => UserModelProps;

export class UserModelBusinessRules {
  private static userModelSelfValidationBusinessRules: UserModelSelfValidationBusinessRuleType[] = [];

  public static runAllSelfValidationRules(userModelProps: UserModelProps): UserModelProps {
    if (userModelProps != null) {
      this.userModelSelfValidationBusinessRules.forEach(rule => {
        userModelProps = rule(userModelProps);
      });
    }

    return userModelProps;
  }

  //#region USER MODEL BUSINESS RULES - SELF-VALIDATION

  //#endregion
}
